import { render, staticRenderFns } from "./cookie-consent.vue?vue&type=template&id=01ae8ea4&scoped=true"
import script from "./cookie-consent.vue?vue&type=script&lang=js"
export * from "./cookie-consent.vue?vue&type=script&lang=js"
import style0 from "./cookie-consent.vue?vue&type=style&index=0&id=01ae8ea4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ae8ea4",
  null
  
)

export default component.exports